export const getVideoThumbUrl = (videoId: string) => {
  const thumbnailUrl = videoId ? `/api/v1/videos/${videoId}/thumb` : "";
  return thumbnailUrl;
};
